<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Rakamlar"
    }
</script>

<style scoped>

</style>